import { Component, OnInit, OnDestroy, Input, AfterViewInit, Output, EventEmitter, ChangeDetectorRef, ElementRef, OnChanges, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { ManagedContentService } from '../shared/service/managed-content.service';
import { UserSessionService } from '../shared/service/user-session.service';
import { CmElement, CmHelp, CmSection, ContentType } from '../shared/model/cm/managed-content.model';
import { UntypedFormGroup, UntypedFormControl, Validators, FormGroup, FormControl, ReactiveFormsModule, AsyncValidatorFn,AbstractControl,ValidationErrors } from '@angular/forms';
import { Notice } from '../shared/model/session/notice'
import { MhsService } from '../shared/service/mhs.service';
import { AuthGuardService } from '../shared/service/auth-guard.service';
import { of } from 'rxjs';
import { AppInsightsApiService } from '../shared/service/app-insights-api.service';
import { ViewportScroller, TitleCasePipe } from '@angular/common';
import { ApplicationService } from '../shared/service/application.service';
import { COMPANY_ID, GlobalConstants } from '../shared/global-constants';
import { AppInsightsLoggerService } from '../shared/service/app-insights-logger.service';
import { WindowRef } from '../shared/service/window.service';
import { ModalService } from '../shared/service/modal.service';
import { FormUtils } from '../shared/helper/form-utils';
import { CmDialog } from '../shared/model/cm-dialog';
import { GoogleAnalyticsService } from '../shared/service/google-analytics.service';
import { FormControlUtilitiesService } from '../shared/service/form-control-utilities.service';
import { ElectronicCommunicationMhs } from '../shared/model/session/electronic-communication-mhs';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { PartialSaveService } from '../shared/service/partial-save.service';
import { PartialSaveResp } from '../shared/model/partial-save-resp';
import { environment } from '@environment';
import { MhsApplicationResponse } from '../shared/model/mhs-application';

@Component({
  selector: 'app-electronic-communication',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './electronic-communication.component.html',
  styleUrls: ['./electronic-communication.component.scss'],
  providers: [TitleCasePipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ElectronicCommunicationComponent implements OnInit, AfterViewInit, OnDestroy  {
  private _baseElectronicLabel: string = '';
  private employeeLabelInterval: any;
    @Output() cancelEmitter = new EventEmitter<void>();
    @Output() backEmitter = new EventEmitter<void>();
    @Output() val = new EventEmitter<boolean>();
    /**
     * Fires the moment the user clicks Submit, BEFORE this component's own
     * form validation runs. Parents can use this to validate sibling sections
     * (e.g. auth-sign acknowledgement) in parallel so all errors show together.
     */
    @Output() submitAttempted = new EventEmitter<void>();
    @Input() showBackButton: boolean = false;
    /**
     * Optional parent-provided validator. Invoked AFTER `submitAttempted`
     * fires (which lets the parent mark its own forms as touched) and BEFORE
     * this component starts its async submit pipeline. If it returns false,
     * the submit is aborted entirely — no network calls, no later val.emit.
     * This prevents the in-flight submission race where the user corrects a
     * sibling form after clicking Submit and the late network response
     * navigates them away unexpectedly.
     */
    @Input() externalValidationFn: () => boolean = () => true;

    public environmentName: string;

    private cancelContent: CmHelp = this.cmService.getContentById(ContentType.HELP, "lose-data-warning");
    public modalContentHeading: string = this.cancelContent.title;
    public modalContentBody: string = FormUtils.sanitize(this.cancelContent.body);
    errorModalDialogContent: CmDialog;
    errorModalContent: Notice;
    public errorModalContentHeading: string = "";
    public errorModalContentBody: string = "";
    public isElectronicCommunicationValid: boolean = true;
    public formNumber: string = this.userSessionService.data.formNumber;
    public isGenericDynamicForm: boolean = this.userSessionService.data.isGenericDynamicForm;
    public isFormSubmitted: boolean = false;
    
    backButtonDialogContent: CmDialog = {
        id: "backModal",
        heading: this.modalContentHeading,
        body: this.modalContentBody,
        size: "medium",
    };

    // GA4 Custom events
    public submitElectronicCommunication = {
        action: "button_click",
        category: "auth-use-release-info",
        name: "submit",
    }

    public cancelElectronicCommunication = {
        action: "button_click",
        category: "auth-use-release-info",
        name: "cancel",
    }

    public consent: string;
    
    public radioButtonOptions = [
      { name: 'no', label: 'No' },
      { name: 'yes', label: 'Yes by email' },
    ];

    @Input() parentForm: UntypedFormGroup;
    electronicCommunicationForm : FormGroup;

    hasElectronicCommunicationElement: CmElement;
    electronicCommunicationEmailElement: CmElement;
    notices: Notice[];
    authAckContinueContent: Notice;
    public authAckContinueContentTitle: string;
    public authAckContinueContentBody: string;

    formSubmitted: boolean;
    spinnerSubmit: boolean = false;

  constructor(private router: Router,
        private cmService: ManagedContentService,
        private userSessionService: UserSessionService,
        private googleAnalyticsService: GoogleAnalyticsService,
        private mhsService: MhsService,
        private authGuardService: AuthGuardService,
        private appInsightsApiService: AppInsightsApiService,
        private el: ElementRef,
        private scroller: ViewportScroller,
        private applicationService: ApplicationService,
        private appInsightsLoggerService: AppInsightsLoggerService,
        private modalService: ModalService,
        private windowService: WindowRef,
        public formControlUtilitiesService: FormControlUtilitiesService,
        private cdr: ChangeDetectorRef,
        private titleCasePipe: TitleCasePipe,
        private partialSaveService: PartialSaveService
        ) {
  }
  private log(content: string) {
    this.appInsightsLoggerService.log('info', 'Info log from applicant-info.component', content);
  }
  ngOnInit(): void {

    this.environmentName = environment.name;

    // Clear previous interval if exists
    if (this.employeeLabelInterval) {
      clearInterval(this.employeeLabelInterval);
    }
        if(this.userSessionService.data.sessionEnded){
            this.router.navigate(['/instructions']);
        }
        
        this.notices = this.userSessionService.data.notices;
      
        if(this.notices){
          this.authAckContinueContent = this.notices["authAckContinue"];  
          if(this.authAckContinueContent !== undefined && this.authAckContinueContent !== null){
            this.authAckContinueContentTitle = this.authAckContinueContent.title;
            this.authAckContinueContentBody = this.authAckContinueContent.body;
          }
        }
        
        this.formSubmitted = false;
        this.appInsightsLoggerService.log('info', 'Electronic Communication Component: Spinner Stopped.' + ' mhsId/caseId: ' + this.userSessionService.data.mhsId, '');

  const originalElectronicElement = this.cmService.getContentById(ContentType.ELEMENT, 'electronic-communication');
  this.hasElectronicCommunicationElement = { ...originalElectronicElement };
  this._baseElectronicLabel = originalElectronicElement.label.charAt(0).toUpperCase() + originalElectronicElement.label.slice(1);
  // Always reset label and prefix when starting a new application
  this.hasElectronicCommunicationElement.label = this._baseElectronicLabel;
  let lastNamePrefix = '';
        this.electronicCommunicationEmailElement = this.cmService.getContentById(ContentType.ELEMENT, 'email');
        // Check for saved form data in session
        const savedElectronicCommData = this.userSessionService.data['electronicCommunicationFormData'];
        
        // Check if form already exists in parent (user navigated back to this page)
        if (this.parentForm && this.parentForm.contains('electronicCommunication')) {
            // Use existing form to preserve data
            this.electronicCommunicationForm = this.parentForm.get('electronicCommunication') as UntypedFormGroup;
        } else {
            // Create new form for first visit
        this.electronicCommunicationForm = new UntypedFormGroup({
          hasElectronicCommunication: new UntypedFormControl(null, [Validators.required]),
          electronicCommunicationEmail: new UntypedFormControl(null),
        });
        
        this.electronicCommunicationForm.get('hasElectronicCommunication')?.valueChanges.subscribe(value => {
          const emailControl = this.electronicCommunicationForm.get('electronicCommunicationEmail');
          if (value === 'yes') {
            emailControl?.setValidators([ Validators.pattern(GlobalConstants.EMAIL_PATTERN), Validators.maxLength(255), Validators.required])
            emailControl?.setAsyncValidators([this.validateEmailAddress()]);
          } else {
            emailControl?.clearValidators();
          }
          emailControl?.updateValueAndValidity();
        });
      } 
        this.electronicCommunicationForm.updateValueAndValidity();

        // Add form to parent if it was newly created inside a shared parent form
        const wasNewlyCreated = this.parentForm && !this.parentForm.contains('electronicCommunication');
        if (wasNewlyCreated) {
            this.parentForm.addControl('electronicCommunication', this.electronicCommunicationForm);
        }

        // Restore saved data for standalone renders and for newly created shared forms.
        const shouldRestoreSavedData = !!savedElectronicCommData && (!this.parentForm || wasNewlyCreated);
        if (shouldRestoreSavedData) {
            // Set values synchronously first to prevent validation flash
            Object.keys(savedElectronicCommData).forEach(key => {
                const control = this.electronicCommunicationForm.get(key);
                if (control && savedElectronicCommData[key] !== null && savedElectronicCommData[key] !== undefined) {
                    control.setValue(savedElectronicCommData[key], { emitEvent: false });
                    // Mark as untouched and pristine immediately to prevent validation errors
                    control.markAsUntouched();
                    control.markAsPristine();
                }
            });
            
            setTimeout(() => {
                Object.keys(savedElectronicCommData).forEach(key => {
                    const control = this.electronicCommunicationForm.get(key);
                    if (control && savedElectronicCommData[key] !== null && savedElectronicCommData[key] !== undefined) {
                        control.setValue(savedElectronicCommData[key], { emitEvent: true });
                        // Mark as untouched and pristine to prevent validation errors from showing
                        control.markAsUntouched();
                        control.markAsPristine();
                        control.updateValueAndValidity();
                    }
                });
            }, 100);
        }

  // employee info and update label when available
        this.employeeLabelInterval = setInterval(() => {
          const applicantType = this.userSessionService.data?.applicantType?.toLowerCase();
          let firstName = '';
          let lastName = '';
          if (applicantType === 'spouse') {
            firstName = this.userSessionService.data?.mhsApplication?.applicant?.firstName || '';
            lastName = this.userSessionService.data?.mhsApplication?.applicant?.lastName || '';
          } else if (["employee", "child"].includes(applicantType)) {
            firstName = this.userSessionService.data?.mhsApplication?.employee?.firstName || '';
            lastName = this.userSessionService.data?.mhsApplication?.employee?.lastName || '';
          }

          const fullName = `${firstName} ${lastName}`.trim();
          const titleCasedName = this.titleCasePipe.transform(fullName);
          if (firstName && lastName && ["employee", "child", "spouse"].includes(applicantType)) {
            const namePrefix = `${titleCasedName}, `;
            if (namePrefix !== lastNamePrefix) {
              // Always reset to base label before updating
              this.hasElectronicCommunicationElement.label = this._baseElectronicLabel;
              this.hasElectronicCommunicationElement.label = namePrefix + this._baseElectronicLabel;
              this.cdr.detectChanges();
              lastNamePrefix = namePrefix;
            }
          }
        }, 300);

        if(this.userSessionService.data.companyId === COMPANY_ID.NM){
            let systemError = this.cmService.getContentById(ContentType.HELP,"system-error-nm");
            this.errorModalContent = {
              id: systemError.id,
              title: systemError.title,
              body: systemError.body
            };
            this.errorModalContentHeading = this.errorModalContent.title;
            this.errorModalContentBody = FormUtils.sanitize(this.errorModalContent.body);
          } else {
            let systemError = this.cmService.getContentById(ContentType.HELP,"system-error");
            this.errorModalContent = {
              id: systemError.id,
              title: systemError.title,
              body: systemError.body
            };
            this.errorModalContentHeading = this.errorModalContent.title;
            this.errorModalContentBody = FormUtils.sanitize(this.errorModalContent.body);
          }

        if(this.errorModalContent){
          this.errorModalDialogContent = {
            id: "errorModal",
            heading: this.errorModalContent.title,
            body: this.errorModalContent.body,
            size: "medium",
          };
          this.errorModalContentHeading = this.errorModalContent.title;
          this.errorModalContentBody = FormUtils.sanitize(this.errorModalContent.body);
        }

         // Subscribe to resubmit requests from progress bar navigation
        this.mhsService.submitElectronicComm.subscribe(shouldTriggerValidation => {
          if (shouldTriggerValidation) {
            // Mark all form controls as touched to show validation errors
            Object.keys(this.electronicCommunicationForm.controls).forEach(key => {
              const control = this.electronicCommunicationForm.get(key);
              control?.markAsTouched();
              control?.markAsDirty();
              control?.updateValueAndValidity();
            });
            // Trigger change detection to update UI
            this.cdr.detectChanges();
            
            // Reset the trigger after processing
            setTimeout(() => {
              this.mhsService.resubmitElectronicComm(false);
            }, 100);
          }
        });

        this.windowService.nativeDocument
          .querySelector('body')
          .addEventListener('click', (event: Event) => this.onClick(event));
    }

  ngAfterViewInit() {
      this.appInsightsApiService.endNavigationEvent(this.router.url);

      setTimeout( ()=>{
          this.onScrollToTop();
          this.onScrollToTopModal();
          }, 1);
  }

  ngOnDestroy() {
      // Save form data to session before component is destroyed
      if (this.electronicCommunicationForm) {
          const formValue = this.electronicCommunicationForm.value;
          const hasData = Object.values(formValue).some(value => 
              value !== null && value !== undefined && value !== ''
          );
          
          if (hasData) {
              this.userSessionService.data['electronicCommunicationFormData'] = formValue;
          }
      }
    }

  onScrollToTop(){
      this.scroller.setOffset([0, 200]);
      this.scroller.scrollToAnchor('topOfPage');
  }

  onScrollToTopModal(){
      this.scroller.setOffset([0, 200]);
      this.scroller.scrollToAnchor('topOfModal');
  }


  logECRadioChangeEvent(controlName: string){
    this.electronicCommunicationForm.get('hasElectronicCommunication').setValue(controlName);

    if(this.electronicCommunicationForm.get('hasElectronicCommunication').value == '' || this.electronicCommunicationForm.get('hasElectronicCommunication').value == null){
      this.isElectronicCommunicationValid = false;
    } else {
      this.isElectronicCommunicationValid = true;
    }

    const employeeEmail = this.userSessionService.data.mhsApplication?.applicant?.email;
      if (controlName ==='yes' && employeeEmail) {
        this.electronicCommunicationForm.get('electronicCommunicationEmail').setValue(employeeEmail);
        this.cdr.detectChanges();
      }  
  }
    
  emailLeaveEvent(controlName: string){

  }

  public onCancel(){
    this.cancelEmitter.emit();
  }

  public onBack(){
    this.backEmitter.emit();
  }

  onSubmitButtonClick(event?: Event){
    // Ignore synthetic clicks. Prism web-components can dispatch a click on
    // their internal <button type="submit"> when the host form receives a
    // synthetic submit event (e.g. after markAllAsTouched() in a production
    // build). Those events have isTrusted === false. Real user clicks always
    // have isTrusted === true, so this is a safe filter.
    // Also ignore synthetic clicks from Cypress tests, which also have isTrusted === false.
    if (event && (event as any).isTrusted === false && !(window as any).Cypress) {
      return;
    }

    // Notify parent immediately so it can validate sibling sections and so
    // sibling error messages appear at the same time as ours.
    this.submitAttempted.emit();

    // Surface our own validation errors regardless of sibling validity.
    this.electronicCommunicationForm.markAllAsTouched();
    this.electronicCommunicationForm.updateValueAndValidity();

    // Abort if either our form or any sibling form is invalid. This prevents
    // kicking off the async submit pipeline whose late response would
    // otherwise navigate the user away once they fix the other section.
    if (!this.electronicCommunicationForm.valid || !this.externalValidationFn()) {
      return;
    }

    this.isFormSubmitted = true;
    this.onSubmit();
  }

  async onSubmit(): Promise<void>{
    if(this.isFormSubmitted){
      //check that we aren't in maintenance mode

      //do not check for the maintenance mode if we are running locally
      if(window.location.href.startsWith("http://localhost")){
        this.submitForm();
      } else {
        let result = await this.userSessionService.checkForSystemMaintenance();
        if(!result){//the above call will return "true" if we are in maintenance mode
          this.submitForm();
        }
      }
    }

    this.isFormSubmitted = false;
    
  }

  submitForm(){
    if(this.environmentName === 'demonstration'){
      this.SubmitDemoMode();
    } else {
      this.submitPartialForm();
    }
  }

  public SubmitDemoMode(){
    this.googleAnalyticsService.sendCustomEvent(this.submitElectronicCommunication);
    this.electronicCommunicationForm.markAllAsTouched();
    
    if(this.electronicCommunicationForm.valid){
      this.fillInElectronicCommunication();
      
        this.userSessionService.data.mhsApplication.agreedOrAcknowledged = "true";
        this.formSubmitted = true;
        this.spinnerSubmit = true;

        this.userSessionService.data.submitDate = new Date();

        //NOTE: DEMO MODE DOES NOT GENERATE A PDF

        this.formSubmitted = true;

        //cleanup
        this.mhsService.updateSubmission(false);
        this.mhsService.resubmitEmployeeInfo(false);
        this.mhsService.resubmitApplicantInfo(false);
        this.mhsService.resubmitPhysician(false);
        this.mhsService.resubmitAuthSign(false);
        this.mhsService.resubmitElectronicCommunication(false);
        this.mhsService.resubmitMedicalHistory(false);
        this.mhsService.physicianErrorThrown = false;
        this.mhsService.updateThrowPhysicianError(false);
          
        this.val.emit(this.formSubmitted);

    } else {

      const firstInvalidControl: HTMLElement = this.el.nativeElement.querySelector(
        "form .ng-invalid"
        );
      FormUtils.scrollToFirstInvalidControl(firstInvalidControl);

      this.formSubmitted = false;
      this.spinnerSubmit = false;
    }
  }

  public submitPartialForm(){
    this.googleAnalyticsService.sendCustomEvent(this.submitElectronicCommunication);
    this.electronicCommunicationForm.markAllAsTouched();
    
    if(this.electronicCommunicationForm.valid){
      this.fillInElectronicCommunication();
      
        this.userSessionService.data.mhsApplication.agreedOrAcknowledged = "true";
        // In the merged review flow, persist auth-sign acknowledgement alongside
        // electronic communication before final submit.
        this.partialSaveService.updateAcknowledgements();
        this.partialSaveService.updateElectronicCommunication();
        this.formSubmitted = true;
        const spinnerStartTime = new Date().getTime();
        this.appInsightsLoggerService.log('info', 'Electronic Communication Component: Spinner Started.' + ' mhsId/caseId: ' + this.userSessionService.data.mhsId, '');
        this.spinnerSubmit = true;

        try{
            this.applicationService.submitFinalCloudApplication(this.userSessionService.data.mhsId, 
            this.userSessionService.data.mhsApplication.applicant.stateOfResidence,
            this.userSessionService.data.mhsApplication.policyNumber,
            this.userSessionService.data.mhsApplication.companyId,
            this.userSessionService.data.mhsApplication)
          .subscribe((response: PartialSaveResp) => {
            this.spinnerSubmit = true;
            if(response === undefined || response === null) {
              this.appInsightsLoggerService.log('info', 'An error occurred while generating the PDF.  Either the MHS ID or the PDF is in invalid.  User got the Something Went Wrong message. mhsId/caseId: ' + this.userSessionService.data.mhsId, '');
              this.raiseSomethingWentWrongModal(spinnerStartTime);
              return;
            } else {
              if(response.data.pdfId === undefined || response.data.pdfId === null || response.data.pdfId === '') {
                this.appInsightsLoggerService.log('info', 'An error occurred while generating the PDF.  User got the Something Went Wrong message. mhsId/caseId: ' + this.userSessionService.data.mhsId, '');
                this.raiseSomethingWentWrongModal(spinnerStartTime);
                return;
              }
            }

            this.userSessionService.data.mhsId = response.data.mhsId;
            this.userSessionService.data.pdfId = response.data.pdfId;
            this.userSessionService.data.submitDate = new Date();

            this.partialSaveService.updateFlowStatusToReady();

            //cleanup
            this.mhsService.updateSubmission(false);
            this.mhsService.resubmitEmployeeInfo(false);
            this.mhsService.resubmitApplicantInfo(false);
            this.mhsService.resubmitPhysician(false);
            this.mhsService.resubmitAuthSign(false);
            this.mhsService.resubmitElectronicCommunication(false);
            this.mhsService.resubmitMedicalHistory(false);
            this.mhsService.physicianErrorThrown = false;
            this.mhsService.updateThrowPhysicianError(false);
            
            // Track this submission
            const submissionId = this.userSessionService.data.getSubmissionIdentifier();
            if (!this.userSessionService.data.submittedApplicantTypes) {
              this.userSessionService.data.submittedApplicantTypes = [];
            }
            if (!this.userSessionService.data.submittedApplicantTypes.includes(submissionId)) {
              this.userSessionService.data.submittedApplicantTypes.push(submissionId);
            }
            
            this.val.emit(this.formSubmitted);
            this.formSubmitted = false;
            const spinnerStopTime = new Date().getTime();
            const spinnerDuration = spinnerStopTime - spinnerStartTime;
            this.appInsightsLoggerService.log('info', 'Electronic Communication Component: Spinner Duration: ' + spinnerDuration + 'ms' + ' mhsId/caseId: ' + this.userSessionService.data.mhsId, '');
            },
          (error: any) => {
            // For local development: ignore PDF generation errors and proceed anyway
            if ((this.environmentName === 'demonstration' || window.location.href.startsWith("http://localhost")) 
                && error?.error?.httpStatusCode === 500 
                && error?.error?.message?.includes('Error generating PDF')) {
              this.appInsightsLoggerService.log('info', 'LOCAL MODE: Ignoring PDF generation error and proceeding to confirmation. mhsId/caseId: ' + this.userSessionService.data.mhsId, '');
              
              // Set mock data and proceed
              this.userSessionService.data.submitDate = new Date();
              this.userSessionService.data.pdfId = 'local-mock-pdf-id';
              
              // Cleanup
              this.mhsService.updateSubmission(false);
              this.mhsService.resubmitEmployeeInfo(false);
              this.mhsService.resubmitApplicantInfo(false);
              this.mhsService.resubmitPhysician(false);
              this.mhsService.resubmitAuthSign(false);
              this.mhsService.resubmitElectronicCommunication(false);
              this.mhsService.resubmitMedicalHistory(false);
              this.mhsService.physicianErrorThrown = false;
              this.mhsService.updateThrowPhysicianError(false);
              
              // Track this submission
              const submissionId = this.userSessionService.data.getSubmissionIdentifier();
              if (!this.userSessionService.data.submittedApplicantTypes) {
                this.userSessionService.data.submittedApplicantTypes = [];
              }
              if (!this.userSessionService.data.submittedApplicantTypes.includes(submissionId)) {
                this.userSessionService.data.submittedApplicantTypes.push(submissionId);
              }
              
              this.val.emit(true);
              this.spinnerSubmit = false;
              return;
            }
            
            // Normal error handling for non-local or other errors
            this.appInsightsLoggerService.log('error', 'Error log from Mhs.component', JSON.stringify(error));
            this.formSubmitted = false;
            this.appInsightsLoggerService.log('info', 'Electronic Communication Component: Spinner Stopped.' + ' mhsId/caseId: ' + this.userSessionService.data.mhsId, '');
            const spinnerStopTime = new Date().getTime();
            const spinnerDuration = spinnerStopTime - spinnerStartTime;
            this.appInsightsLoggerService.log('info', 'Electronic Communication Component: Spinner Duration: ' + spinnerDuration + 'ms' + ' mhsId/caseId: ' + this.userSessionService.data.mhsId, '');

            this.modalContentBody = this.errorModalContentBody;  
            this.modalContentHeading = this.errorModalContentHeading;

            this.modalService.showModal('prism-ui-modal-error-modal'); // Use the service to show the modal

            this.spinnerSubmit = false;
          });
        }
        catch (error){
          const errorAny = error as any;
          const errorStatus = errorAny.status;
          this.appInsightsLoggerService.log('error', 'Error log from Mhs.component', JSON.stringify(error));
          this.formSubmitted = false;
          this.appInsightsLoggerService.log('info', 'Electronic Communication Component: Spinner Stopped.' + ' mhsId/caseId: ' + this.userSessionService.data.mhsId, '');
          const spinnerStopTime = new Date().getTime();
          const spinnerDuration = spinnerStopTime - spinnerStartTime;
          this.appInsightsLoggerService.log('info', 'Electronic Communication Component: Spinner Duration: ' + spinnerDuration + 'ms' + ' mhsId/caseId: ' + this.userSessionService.data.mhsId, '');

          this.modalContentBody = this.errorModalContentBody;  
          this.modalContentHeading = this.errorModalContentHeading;

          this.modalService.showModal('prism-ui-modal-error-modal'); // Use the service to show the modal

          this.spinnerSubmit = false;
        }

    } else {

      const firstInvalidControl: HTMLElement = this.el.nativeElement.querySelector(
        "form .ng-invalid"
        );
      FormUtils.scrollToFirstInvalidControl(firstInvalidControl);

      this.formSubmitted = false;
      this.appInsightsLoggerService.log('info', 'Electronic Communication Component: Spinner Stopped.' + ' mhsId/caseId: ' + this.userSessionService.data.mhsId, '');
      this.spinnerSubmit = false;
    }
  }

  raiseSomethingWentWrongModal(spinnerStartTime: number){
    this.formSubmitted = false;
    this.appInsightsLoggerService.log('info', 'Electronic Communication Component: Spinner Stopped.' + ' mhsId/caseId: ' + this.userSessionService.data.mhsId, '');
    const spinnerStopTime = new Date().getTime();
    const spinnerDuration = spinnerStopTime - spinnerStartTime;
    this.appInsightsLoggerService.log('info', 'Electronic Communication Component: Spinner Duration: ' + spinnerDuration + 'ms' + ' mhsId/caseId: ' + this.userSessionService.data.mhsId, '');

    this.modalContentBody = this.errorModalContentBody;  
    this.modalContentHeading = this.errorModalContentHeading;

    this.modalService.showModal('prism-ui-modal-error-modal'); // Use the service to show the modal
  }

  fillInElectronicCommunication(){
    let electronicCommunication = new ElectronicCommunicationMhs();
    if(this.userSessionService.data.mhsApplication != undefined){
      electronicCommunication.hasElectronicCommunication = this.electronicCommunicationForm.get("hasElectronicCommunication").value;
      electronicCommunication.electronicCommunicationEmail = this.electronicCommunicationForm.get("electronicCommunicationEmail").value;
      this.userSessionService.data.mhsApplication.electronicCommunication = electronicCommunication;
    }
  }

  resetSpinner(){
      this.spinnerSubmit = false;
  }

  onAuthAckContinue(event?: Event){
    event?.preventDefault();
    event?.stopPropagation();

    this.modalContentHeading = this.authAckContinueContent.title;
    this.modalContentBody = this.authAckContinueContent.body;

    this.modalService.showModal('prism-ui-modal-auth-ack-continue-modal');
  }

  leaveAnyway(){
    this.userSessionService.clearSession();
    this.userSessionService.data.sessionEnded = true;
    this.authGuardService.cancelLeaveAnyway();
    this.router.navigate(['/instructions']);
  }

  onCancelModal(modalName: string){
    const modalElement =
      this.windowService.nativeDocument.getElementById(modalName);

    if (modalElement && modalElement.close) {
      modalElement.close();
    } else {
      this.appInsightsLoggerService.log('info', 'Info log from ApplicantType.component', `Modal with id ${modalName} not found or doesn't support close method.`);
    }
  }

  // use the window service to access the modal element
  // and close the modal when the user clicks outside of it
  onClick(event: Event) {
    const modal = this.windowService.nativeDocument.getElementById(
      'prism-ui-modal-cancel-modal'
    );

    if (modal && event.target === modal) {
      this.onCancelModal('prism-ui-modal-cancel-modal');
    }

    const modal2 = this.windowService.nativeDocument.getElementById(
      'prism-ui-modal-auth-ack-continue-modal'
    );

    if (modal2 && event.target === modal2) {
      this.onCancelModal('prism-ui-modal-auth-ack-continue-modal');
    }
  }

  canDeactivate(){
    if (!this.formSubmitted && !this.userSessionService.data.sessionEnded){
      this.modalContentHeading = this.cancelContent.title;
      this.modalContentBody = FormUtils.sanitize(this.cancelContent.body);
      this.modalService.showModal('prism-ui-modal-cancel-modal'); // Use the service to show the modal
      return this.userSessionService.data.sessionEnded;
    } else {
      return of(true);
    }
  }
  validateEmailAddress(): AsyncValidatorFn {
  return (electronicCommunicationEmail: AbstractControl): Promise<ValidationErrors | null> => {

    return new Promise((resolve) => {

      if (!electronicCommunicationEmail.value) {
        resolve(null);
        return;
      }

      if (!this.mhsService) {
        resolve(null);
        return;
      }

      this.mhsService.isValidEmailAddress(electronicCommunicationEmail.value).subscribe(
        (res) => {
          resolve(res ? null : { invalidEmail: true });
        },
        (err) => {
          this.log(
            'Invalid email address entered: ' +
            electronicCommunicationEmail.value +
            ' Error: ' +
            JSON.stringify(err)
          );
          resolve({ invalidEmail: true });
        }
      );

    });
  };
}

}
